
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbRelatorioPrimeiroAcessoConta extends AppService {
  abstract getAllAcessos(filter: AppFilter): Observable<any>;
  abstract getGrupos();
  abstract getRelatorio(filter: AppFilter): Observable<any>;
}